<template>
  <div>
    <CKEditor
      v-model="detail"
      :editor="classicEditor"
      :config="editorConfig"
      @ready="initDocumentEditor"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onUpdated } from 'vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'

import TablePlugin from '@ckeditor/ckeditor5-table/src/table'
import TableToolbarPlugin from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import TablePropertiesPlugin from '@ckeditor/ckeditor5-table/src/tableproperties'
import TableCellPropertiesPlugin from '@ckeditor/ckeditor5-table/src/tablecellproperties'

import Font from '@ckeditor/ckeditor5-font/src/font'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough'
import TodoListPlugin from '@ckeditor/ckeditor5-list/src/todolist'
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment'

export default defineComponent({
  name: 'text-editor',
  props: {
    modelValue: String
  },
  setup(props, context) {
    const classicEditor = ClassicEditor
    const editorConfig = {
      plugins: [
        Font,
        EssentialsPlugin,
        BoldPlugin,
        UnderlinePlugin,
        StrikethroughPlugin,
        ItalicPlugin,
        TablePlugin,
        TablePropertiesPlugin,
        TableToolbarPlugin,
        TableCellPropertiesPlugin,
        ParagraphPlugin,
        TodoListPlugin,
        AlignmentPlugin
      ],
      toolbar: {
        items: [
          'fontSize',
          'fontColor',
          'fontBackgroundColor',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'undo',
          'redo',
          'insertTable',
          // 'numberedList',
          // 'bulletedList',
          'todoList',
          'alignment'
        ]
      },
      table: {
        contentToolbar: [
          'tableColumn',
          'tableRow',
          'mergeTableCells',
          'tableProperties',
          'tableCellProperties'
        ]
      },
      alignment: {
        options: ['left', 'center', 'right']
      }
    }

    const detail = ref(props.modelValue)
    // console.log('detail: ', detail.value)

    onUpdated(() => {
      // console.log('modelValue:', props.modelValue)
      detail.value = props.modelValue
    })

    watch(detail, newVal => {
      // console.log('set timeout')
      context.emit('update:modelValue', newVal)
    })

    const initDocumentEditor = editor => {
      // const toolbarContainer = document.querySelector(
      //   '.document-editor__toolbar'
      // )
      // toolbarContainer?.appendChild(editor.ui.view.toolbar.element)
      // const win = window
      // console.log('win: ', win, editor, toolbarContainer)
      // win.editor = editor
    }

    return {
      classicEditor,
      editorConfig,
      initDocumentEditor,
      detail
    }
  }
})
</script>

<style scoped></style>
